import { space } from 'styled-system';
import { styled } from "../utils";
var Main = styled.main(function (_a) {
    var backgroundColor = _a.backgroundColor, colors = _a.theme.colors;
    return "\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  background-color: " + (backgroundColor || colors.backgroundPrimary) + ";  \n";
}, space);
export default Main;
//# sourceMappingURL=Main.js.map